import React from "react";
import { useTranslation } from "react-i18next";
import { Tab } from "semantic-ui-react";
import vizygood from "../../assets/vizyshadowed.png";
import RestoreForm from "./resetpassword";
import "./login.scss";
import LoginForm from "./LoginForm";
import SubscriptionForm from "./signup";
import title from "./title.svg";

const Login = function () {
  const { t } = useTranslation();

  const panes = [
    {
      menuItem: t("profile.login"),
      render: () => (
        <Tab.Pane>
          <LoginForm data-id="loginform" />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("profile.signup"),
      render: () => (
        <Tab.Pane>
          <SubscriptionForm data-id="loginform" />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("profile.resetPassword"),
      render: () => (
        <Tab.Pane>
          <RestoreForm />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="max-w-[350px] mx-auto sm:max-w-[500px] px-4 sm:px-0">
      <div className="flex justify-center">
        <img src={vizygood} className="w-[80px] sm:w-[120px] mt-4" />
      </div>
      <div className="mt-5 mb-10 flex justify-center">
        <img src={title} className="animated jackInTheBox" />
      </div>
      <div id="tabcontainer" className="max-w-full md:max-w-[500px] mx-auto my-2 md:my-4 px-2 md:px-0">
        <Tab
          panes={panes}
          menu={{
            attached: true,
            tabular: true,
            className: "overflow-x-scroll no-scrollbar",
          }}
        />
      </div>
    </div>
  );
};

export default Login;
